/**
 * Convert '1-3, 5, 7-8' to zero-based page indices in original document order.
 * Invalid input is rejected rather than silently exporting unintended pages.
 */
export function parsePageRanges(expression, total) {
  if (!Number.isSafeInteger(total) || total < 1) throw new Error('Döküman boş.');
  const parts = expression.split(',').map((value) => value.trim());
  if (!parts.length || parts.some((part) => !part)) {
    throw new Error('Sayfa aralığını örnekteki gibi girin: 1-3, 5, 8');
  }
  const result = new Set();
  for (const part of parts) {
    const match = /^(\d+)(?:\s*-\s*(\d+))?$/.exec(part);
    if (!match) throw new Error(`Geçersiz sayfa aralığı: ${part}`);
    const start = Number(match[1]);
    const end = match[2] ? Number(match[2]) : start;
    if (start < 1 || start > total || end < start || end > total) {
      throw new Error(`Sayfa numaraları 1-${total} arasında ve artan sırada olmalıdır.`);
    }
    for (let value = start; value <= end; value++) result.add(value - 1);
  }
  return [...result].sort((a, b) => a - b);
}

export function movePage(pages, sourceId, targetId) {
  const sourceIndex = pages.findIndex((page) => page.id === sourceId);
  const targetIndex = pages.findIndex((page) => page.id === targetId);
  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) return pages;
  const next = [...pages];
  const [removed] = next.splice(sourceIndex, 1);
  next.splice(targetIndex, 0, removed);
  return next;
}
